import { formatCoachingTime } from '@efdigital/ll-addon-coaching/utils/coaching-sessions/format-coaching-time';
import formatDate, {
  DateFormat,
} from '@efdigital/ll-addon-content/helpers/format-date';
import type { CoachingConfig } from '@efdigital/ll-addon-data/types/coaching/coaching-config';
import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';

interface CoachingConfigRowSignature {
  Args: {
    coachingConfig: CoachingConfig;
  };
  Element: HTMLDivElement;
}

const CoachingConfigRow: TOC<CoachingConfigRowSignature> = <template>
  <LinkTo
    class="coaching-config-card card border shadow-sm rounded-3 text-decoration-none text-body h-100"
    @route="coaching.configs.config"
    @model={{@coachingConfig.id}}
    ...attributes
  >
    <div class="card-body coaching-config-card-body">
      <div class="coaching-config-card-main">
        <p class="coaching-config-card-date mb-2">
          <iconify-icon inline icon="ph:calendar-blank" aria-hidden="true" />
          {{#if @coachingConfig.modified}}
            Created
            {{formatDate @coachingConfig.modified DateFormat.ShortDate}}
          {{else}}
            Created manually
          {{/if}}
        </p>
        <h2
          class="coaching-config-card-title h5 fw-bold mb-3"
        >{{@coachingConfig.name}}</h2>

        <div class="coaching-config-card-badges">
          <span
            class="coaching-config-card-badge coaching-config-card-badge--sessions"
          >
            <iconify-icon inline icon="ph:calendar-blank" aria-hidden="true" />
            {{formatCoachingTime @coachingConfig.coachingTimeMinutes}}
          </span>
          <span class="coaching-config-card-duration">
            <iconify-icon inline icon="ph:clock" aria-hidden="true" />
            {{@coachingConfig.defaultSessionDurationMinutes}}
            min default
          </span>
        </div>
      </div>

      <div class="coaching-config-card-action" aria-hidden="true">
        <iconify-icon inline icon="ph:caret-right" />
      </div>
    </div>
  </LinkTo>
</template>;

export default CoachingConfigRow;
